import { NivalizOutboundTransactionTimerDropOffPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../../pudo/pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface NivalizUrnsAwaitingDropOffProps {
    accountId: string;
    navigateUrl?: string;
}

export const NivalizUrnsAwaitingDropOff = ({ accountId, navigateUrl }: NivalizUrnsAwaitingDropOffProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='platform.statistics.nivaliz.awaiting-drop-off.title'
                description='Title of the Nivaliz dashboard stacked bar showing urns awaiting drop-off grouped by waiting time'
                defaultMessage='Urns: Awaiting drop-off'
            />
        }
        Chart={NivalizOutboundTransactionTimerDropOffPendingWaitingDaysStackedBarChart}
    />
);
